import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
//helpers
import { truncate } from '../../helpers';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//styles
import './blog.scss';

const CardBlog = (props) => {
  const { t } = useTranslation(['blog', 'backoffice']);
  const [dt, setDt] = useState('');
  const [urlBlog, setUrlBlog] = useState('');
  const { featured_image, title, author, publish_date, publish_time, featured_paragraph, slug, body } = props.event;
  const { assignedLibrary } = useAssignedLibrary();

  useEffect(() => {
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    let x = new Date(publish_date).toLocaleDateString('es-ES', options);
    setDt(x);
    var url = `/${assignedLibrary}/blog/${publish_date}/${slug}`;
    setUrlBlog(url);
  }, [publish_date, slug, assignedLibrary]);

  return (
    <Card className="card-blog-card h-100">
      {props.isOnlyPost ? null : (
        <div
          className={`card-blog-image ${props.isFirstPost ? 'first-post' : ''}`}
          style={{ backgroundImage: `url(${featured_image})` }}
        ></div>
      )}
      {props.isOnlyPost ? null : <Card.Title className="card-blog-title px-3 py-2 m-0">{truncate(title)}</Card.Title>}
      <Card.Body>
        <div className="card-blog-author d-flex justify-content-center justify-content-sm-start">
          {t('by')} <div className="card-blog-author-name">{author}</div>{' '}
        </div>
        <div className="card-blog-date">
          {new Date(publish_date).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
          {' a las '}
          {publish_time}
        </div>
        {props.isOnlyPost ? (
          <>
            <div className="card-blog-footer">{featured_paragraph}</div>
            <br />
            <div
              dangerouslySetInnerHTML={{ __html: body }}
              className="card-blog-footer"
            ></div>
          </>
        ) : (
          <div className="card-blog-footer d-flex flex-column">
            {featured_paragraph.length < 45
              ? featured_paragraph + "."
              : truncate(featured_paragraph, 45)}
            <div className="mt-auto">
              <Link
                to={urlBlog}
                className="card-blog-link"
              >
                {t('seeMore', { ns: 'backoffice' })}
              </Link>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

CardBlog.propTypes = {
  event: PropTypes.object,
  isColumn: PropTypes.bool,
  isRow: PropTypes.bool,
  isContainer: PropTypes.bool,
  hasLine: PropTypes.bool,
  isOnlyPost: PropTypes.bool,
};

export default CardBlog;